import { useDispatch, useSelector } from 'react-redux';
import { useCallback } from 'react';

import { Store } from '@/shared/store';
import { hideModalAction, showModalAction } from '@/shared/store/modals/actions';

export const useHideModal = (onClose?: () => void) => {
    const dispatch = useDispatch();
    const { previousModal } = useSelector((state: Store) => ({
        previousModal: state.modals.previousModal,
    }));

    const handleCloseModal = useCallback(() => {
        if (previousModal) {
            dispatch(
                showModalAction({
                    modalName: previousModal.activeModal,
                    modalTitle: previousModal.modalTitle,
                    modalProps: previousModal.modalProps,
                    previousModal: null,
                }),
            );

            return;
        }
        dispatch(hideModalAction());

        if (onClose) {
            onClose();
        }
    }, [dispatch, onClose]);
    return {
        handleCloseModal,
    };
};
